<script>
   import { router } from './Router.svelte';

   export let real = false;
   export let href = '#';
   export let style = null;
   export let target = null;
   export let title = null;
   export let css_class = null;

   const local_go = event => {
      if (!real) {
         event.preventDefault();
         router._go(href);
      }
   }
</script>


<a { href } class="{css_class}" { style } { target } { title } on:click="{ local_go }"><slot/></a>